import { useState, ChangeEvent } from 'react';

import { DictionaryEntry } from 'app/services/dict.service';
import { AutocompleteControlProps } from './AutocompleteControl.interfaces';

export function useAutocompleteControl({
  input,
  meta,
  dictionary = [],
  onValueChange,
  onControlBlur,
}: AutocompleteControlProps) {
  const [focused, setFocused] = useState(false);

  const { touched, valid } = meta;
  const error = touched && !valid;

  const selectedOption =
    dictionary.find((entry) => entry.key === input.value) || null;

  const handleChange = (_: ChangeEvent<{}>, option: DictionaryEntry | null) => {
    const key = option?.key ?? '';

    input.onChange(key);

    if (onValueChange) {
      onValueChange(key, true);
    }
  };

  const handleBlur = () => {
    input.onBlur(input.value);

    if (onControlBlur) {
      onControlBlur();
    }

    setFocused(false);
  };

  return {
    focused,
    setFocused,
    error,
    selectedOption,
    handleChange,
    handleBlur,
  };
}
